// extracted by mini-css-extract-plugin
export default {"root":"acyNl6","truncated":"WPMhK0"};